module.exports = __webpack_public_path__ + "img/fuerstenzell_kreuzgruppe.8ad4262b.jpg";